import { SVGProps } from 'react';

const Cart = ({
  props,
  fill = 'currentColor',
  size = 24,
}: {
  props?: SVGProps<SVGSVGElement>;
  fill?: string;
  size?: string | number;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill={fill}
      d="M7.25 19a1.25 1.25 0 0 0-2.5 0l.006.124A1.25 1.25 0 0 0 7.25 19Zm11 0a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0Zm-11.5-6.75h11.6l.794-5.56L6.75 5.805v6.445Zm13 6.75a2.75 2.75 0 1 1-5.197-1.25H8.447a2.748 2.748 0 0 1-4.391 3.194 2.75 2.75 0 0 1 1.194-4.588V3.75H4a.75.75 0 0 1 0-1.5h2l.077.004A.75.75 0 0 1 6.75 3v1.3l13.304.952a.75.75 0 0 1 .688.854l-1 7a.75.75 0 0 1-.742.644H6.75v2.5H17A2.75 2.75 0 0 1 19.75 19Z"
    />
  </svg>
);

export default Cart;
